export const FETCH_COMMENTS_REQUEST = 'comments/FETCH_REQUEST';
export const FETCH_COMMENTS_SUCCESS = 'comments/FETCH_SUCCESS';
export const FETCH_COMMENTS_FAILURE = 'comments/FETCH_FAILURE';
